const baseURL   = `${process.env.REACT_APP_PUBLIC_API_URL}${process.env.REACT_APP_PUBLIC_API_PORT ? `:${process.env.REACT_APP_PUBLIC_API_PORT}` : ""}`;
const routes    = {
    listRoutersEndpoint:    `${baseURL}/routers/list`,
    executeCommandEndpoint: `${baseURL}/routers/execute`,

    verifyCapcha:           `${baseURL}/capcha/verify`,
}

export default routes;